import { fetchFactory } from 'isotope-client'

export const getSolverStatus = () => fetchFactory('/solver/culture/infos')

export const getSolverTacheStatus = () => fetchFactory('/solver/tache/infos')

export const stopDemande = () => fetchFactory('/solver/culture/stop', { method: 'DELETE' })

export const stopDemandeTaches = () => fetchFactory('/solver/tache/stop', { method: 'DELETE' })

export const launchSolver = () => fetchFactory('/solver/culture/start', { method: 'POST' })
export const launchSolverTaches = (useWeeks) => fetchFactory('/solver/tache/start',
	{
		method: 'POST',
		body: useWeeks
	})

export const approveSolutionCulture = () => fetchFactory('/solver/culture/approveSolution', { method: 'POST' })

export const approveSolutionTache = () => fetchFactory('/solver/tache/approveSolution', { method: 'POST' })

window.approveSolutionTache = approveSolutionTache